export { default } from './CaptchaInput';
